export default {
	"2db9cae3de1545e51ce292dd1c28ce54": "自主订阅商品详情页",
	"e2226b1a4170f9c1303104b265be3494": "自自主订阅商品详情页_购买按钮",
	"0bc2692358647d0447374ab7243fea7e": "选中的支付方式名称"
}
